import React, { useCallback, useRef, useState } from 'react';
import { addParamsToUrl } from 'js/utils/url.util';
import { Button } from 'js/components/common/Button';
import { copyToClipboard } from 'js/utils/clipboard.util';
import { path, prop, compose } from 'js/utils/ramda.util';
import { withComponent } from 'js/components/hocs/withComponent';
import { componentService } from 'js/services/component.service';
import { useAppSelector, useUserSelector } from 'js/store/hooks';
import { ErrorMessage } from 'js/components/common/ErrorMessage';
import { useShowNotification } from 'js/components/common/Notifications';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import { REFER_A_FRIEND } from './constants';

import style from './ReferFriend.scss';

export const ReferFriendBare = () => {
    const buttonRef = useRef();
    const translate = useComponentTranslations();
    const [error, setError] = useState('');
    const userId = useUserSelector(path(['userDetails', 'userId']));
    const registrationURL = useAppSelector(prop('registrationURL'));
    const showNotification = useShowNotification({ iconType: 'info' });
    const message = addParamsToUrl({ referrer: userId }, `${window.location.origin}${registrationURL}`);
    const onClick = useCallback(() => {
        setError('');
        copyToClipboard(message, buttonRef.current)
            .then(() => showNotification({ message: translate('copied') }))
            .catch(() => setError('copyFailed'));
    }, [showNotification, translate, setError, message]);

    return (
        <div className={style.container}>
            <div className={style.title}>{translate('title')}</div>
            <div className={style.message}>{translate('message')}</div>
            {error && <ErrorMessage className={style.error} error={translate('error')} animate={true} />}
            <div className={style.box}>{message}</div>
            <Button
                onClick={onClick}
                buttonRef={buttonRef}
            >
                {translate('button')}
            </Button>
        </div>
    );
};

export const ReferFriend = compose(
    withComponent({ isForLoggedIn: true })
)(ReferFriendBare);

componentService.registerPageComponents({ [REFER_A_FRIEND]: ReferFriend });
